(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .constant('paginationConstants', {
            'itemsPerPage': 5
        });
})();
